import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './home.scss';
import { DataGrid, PieChart, List, Button, LoadPanel, Popup, LoadIndicator } from 'devextreme-react';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import service from '../../data/data.js';
import GlobalParams from '../../helpers/GlobalParams.js';
import ApiHelper from '../../helpers/ApiHelper.js';
import { Navigate } from 'react-router-dom/dist/index.js';
import JsonArrayUtility from '../../helpers/JsonArrayUtility.js';
import SchemeDetails from '../SchemeDetails/SchemeDetails.js';
import { Column } from 'devextreme-react/cjs/data-grid.js';
import CustomTitle from '../CustomTitle/CustomTitle.js';
import notify from 'devextreme/ui/notify';
import axios from 'axios';
import Report from '../reports/reports.js';

const Home = () => {

  function formatNumberWithCommas(value) {
    // Convert value to a string with two decimal places
    const formattedValue = Number(value).toFixed(2);

    // Split the value into integer and decimal parts
    const [integerPart, decimalPart] = formattedValue.split('.');

    // Add commas to the integer part
    const numberWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Combine the integer part with the decimal part
    return numberWithCommas + '.' + decimalPart;
  }

  function formatIntegerWithCommas(value) {
    // Convert value to a string
    const stringValue = value.toString();

    // Check if the value has decimal places
    if (stringValue.includes('.')) {
      // Convert value to a string with two decimal places
      const formattedValue = Number(value).toFixed(2);

      // Split the value into integer and decimal parts
      const [integerPart, decimalPart] = formattedValue.split('.');

      // Add commas to the integer part
      const numberWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // Combine the integer part with the decimal part
      return numberWithCommas + '.' + decimalPart;
    } else {
      // Add commas to the integer part
      return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  const [isLoading, setIsLoading] = useState(true);


  const navigate = useNavigate();  // Get the history object from useHistory()

  const showRpt = () => {
    const dataToSend = 'Data from Claims component';  // Replace this with your actual data
    navigate('/reports', { state: { data: dataToSend } });
  };

  //var claimsData = [];//service.getClaimsStore(); 

  const [benefitsData, setBenefitsData] = useState([]);
  const [SchemeId, setSchemeId] = useState(null);
  const [claimsData, setClaimsData] = useState(null);
  const [schemesData, setData] = useState(null);
  const [endorsementsData, setEndorsementData] = useState([]);
  //const [SchemeBenefit, setSchemeBenefit] = useState();
  const [total_debits, setTotalDebits] = useState('');
  const [total_credits, setTotalCredits] = useState('');
  const [IsCreditLifeCover, setIsCreditLifeCover] = useState('0');
  const [outstanding_amount, setOutstandingAmount] = useState('');
  const [lifeCoverFactor, setLifeCoverFactor] = useState('');
  const [benefitsSchemeData, setBenefitsSchemeData] = useState([]);
  const [isEndorsementLoading, setIsEndorsementLoading] = useState(false);
  const [isClaimLoading, setIsClaimsLoading] = useState(false);

  const currentDate = new Date();

  const filteredSchemes = GlobalParams.schemeStore.filter(scheme => {
    const dateFrom = new Date(scheme.DateFrom);
    const endDate = new Date(scheme.End_date);
    const isActive =
      ((dateFrom <= currentDate && endDate >= currentDate) ||
        scheme.DateFrom === '1900-01-01 00:00:00.000');

    return isActive || scheme.StatusCode === "001";
    //return isActive;
  });

  const fetchData = async () => {
    try {
      //const result = await ApiHelper.fetchData(GlobalParams.ApiUrlPrefix + 'getGroupClients?gc_id=' + GlobalParams.UserEmail, GlobalParams.bearerToken);
      //if(GlobalParams.IsClientLoggedIn){
      let client_url = GlobalParams.ApiUrlPrefix + 'getGroupClients?gc_id=' + GlobalParams.ClientId;
      if (!GlobalParams.IsClientLoggedIn) {
        client_url = GlobalParams.ApiUrlPrefix + 'getGroupClients?intermediary_id=' + GlobalParams.IntermediaryId;
      }
      const result = await axios.get(
        client_url,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );
      /*if (!result.data.success) {
        setIsLoading(false);
      }*/

      GlobalParams.clientStore = result.data.data;
      GlobalParams.ClientId = result.data.data[0].Id;
      GlobalParams.ClientName = result.data.data[0].name;

      //GlobalParams.schemeStore = await fetchClientSchemes(GlobalParams.ClientId);
      //GlobalParams.DebitsData = await fetchDebitsData(GlobalParams.ClientId);
      console.log(GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001")));

      //filter using the dates....
      //setData(filteredSchemes);
      /*if (!GlobalParams.IsClientLoggedIn){
        setData(GlobalParams.clientStore);
      }else{
        */
        setData(filteredSchemes);
      //}
      

      //var tmpSchemesStore = GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001"));
      //lets use the datefrom and end_date to filter the schemes 
      let tmpSchemesStore = GlobalParams.schemeStore.filter(scheme => (scheme.DateFrom <= currentDate && scheme.End_date >= currentDate));

      let tmp_endorsementsStore = [];
      let tmp_claimsData = [];
      let tmp_fetchBenefitsData = [];  //fetchBenefitsData
      //setIsEndorsementLoading(true);
      setIsClaimsLoading(true);
      for (const item of tmpSchemesStore) {
        if (item.StatusCode === "001") {
          if (item.End_date !== undefined && item.End_date !== '' && item.End_date !== null) {
            const scheme_id = item.schemeID;

            if (GlobalParams.IsClientLoggedIn) {
              const benefitForScheme = await fetchBenefitsData(scheme_id);
              tmp_fetchBenefitsData = benefitForScheme;

              //const endorsementsForScheme = await fetchEndorsementsForScheme(scheme_id);
              //tmp_endorsementsStore.push(...endorsementsForScheme);

              const claimForScheme = await fetchClaims(scheme_id);
              tmp_claimsData.push(...claimForScheme);
            }

          }
        }
      }
      setIsEndorsementLoading(false);
      setIsClaimsLoading(false);
      setEndorsementData(tmp_endorsementsStore);
      setClaimsData(tmp_claimsData);
      setBenefitsData(tmp_fetchBenefitsData);
      //service.setSchemesStore(tmpSchemesStore);


      setIsLoading(false);
    } catch (error) {
      // Handle error, e.g., show an error message
      setIsEndorsementLoading(false);
      setIsClaimsLoading(false);
      console.log(error);
      setIsLoading(false);
      //notify(error.response.data.message, 'error', 5000);
    }
  };

  const fetchEndorsements = async (scheme_id) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + 'get-endorsement-requests?scheme_id=' + scheme_id,
        GlobalParams.bearerToken
      );
      return result.data;
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      return [];
    }
  };

  const fetchClaims = async (scheme_id) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + 'get-claim-requests?scheme_id=' + scheme_id,
        GlobalParams.bearerToken
      );
      return result.data;
    } catch (error) {
      // Handle error, e.g., show an error message
      setIsEndorsementLoading(false);
      setIsClaimsLoading(false);
      console.log(error);
      return [];
    }
  };

  const fetchSchemeBenefitsData = async (scheme_id) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + 'scheme-riders?scheme_id=' + scheme_id,
        GlobalParams.bearerToken
      );

      setIsLoading(false);
      setBenefitsSchemeData(result.data);
      setPopupSchemeDetailsVisible(true);
    } catch (error) {
      // Handle error, e.g., show an error message
      setIsEndorsementLoading(false);
      setIsClaimsLoading(false);
      setIsLoading(false);
      console.log(error);
      setPopupSchemeDetailsVisible(true);
    }
  }

  const fetchBenefitsData = async (scheme_id) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + 'scheme-riders?scheme_id=' + scheme_id,
        GlobalParams.bearerToken
      );
      return result.data;
    } catch (error) {
      // Handle error, e.g., show an error message
      setIsEndorsementLoading(false);
      setIsClaimsLoading(false);
      console.log(error);
      return [];
    }
  };

  const fetchDebitsData = async (client_id) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + 'client-debit-notes?gc_id=' + client_id,
        GlobalParams.bearerToken
      );
      return result.data;
    } catch (error) {
      // Handle error, e.g., show an error message
      setIsEndorsementLoading(false);
      setIsClaimsLoading(false);
      console.log(error);
      return [];
    }
  };


  useEffect(() => {
    fetchData();
  }, []);

  const fetchEndorsementsForScheme = async (scheme_id) => {
    try {
      const endorsements = await fetchEndorsements(scheme_id);
      return endorsements;
    } catch (error) {
      setIsEndorsementLoading(false);
      setIsClaimsLoading(false);
      console.error(`Error fetching endorsements for scheme ${scheme_id}:`, error);
      return [];
    }
  };

  const fetchClientSchemes = async (clientId) => {
    //if (!clientId) return;
    try {

      let url = GlobalParams.ApiUrlPrefix + 'contact-allowed-person-schemes?contact_person_id=' + GlobalParams.ContactPersonId;
      if (!GlobalParams.IsClientLoggedIn) {
        // url = GlobalParams.ApiUrlPrefix + 'schemes-under-broker?broker_id=' + GlobalParams.IntermediaryId;
        url = GlobalParams.ApiUrlPrefix + 'contact-allowed-person-schemes?contact_person_id=' + GlobalParams.ContactPersonId;
      }
      const result = await ApiHelper.fetchData(
        url,
        GlobalParams.bearerToken
      );

      setSchemeId(result.data.schemeID);
      console.log(result.data[0].schemeID);

      //setCardHeight(result.data.length * 750);

      return result.data;
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
    }
  };

  // Grid columns definition for recent claims 
  const gridColumns = [
    { dataField: 'scheme_id', visible: false },
    {
      dataField: 'policy_no', caption: 'Scheme Number',
      groupIndex: 0
    },
    { dataField: 'Description', caption: 'Claim Type', groupIndex: 1 },
    { dataField: 'Names', caption: 'Claimant' },
    { dataField: 'NotificationDate' },
    { dataField: 'claim_no', caption: 'Claim No' },
    { dataField: 'ClaimStatus' },
  ];

  //, caption: 'benefit', groupIndex: 0
  const benefitsColumns = [
    { dataField: 'description' },
    { dataField: 'CategoryName' },
    { dataField: 'PercentageApplicable', visible: false }
  ];

  const endorsementsColumns = [
    { dataField: 'scheme_id', visible: false },
    {
      dataField: 'policy_number', caption: 'Scheme Number',
      groupIndex: 0
    },
    {
      dataField: 'EndorsementType',
      groupIndex: 1
    },
    { dataField: 'Member', visible: false },
    { dataField: 'MemberName', caption: 'Name' },
    { dataField: 'MemberAge', caption: 'Age', visible: false },
    { dataField: 'MemberNo', caption: 'Staff No' },
    { dataField: 'EffectiveDate', dataType: 'date' },
    { dataField: 'Status', groupIndex: 2 },
    { dataField: 'MemberSalary', caption: 'Salary', visible: false },
    { dataField: 'IdType', visible: false },
    { dataField: 'IdNumber', visible: false },
    { dataField: 'HasDependants', dataType: 'boolean', visible: false },
    { dataField: 'EndorsementRequest', visible: false }
  ];

  //endorsementsData, endorsementsColumns
  const [popupSchemeDetailsVisible, setPopupSchemeDetailsVisible] = useState(false);
  const hideSchemeDetailsPopup = () => {
    setPopupSchemeDetailsVisible(false);
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  return (
    <div>
      {/* {isLoading && <LoadPanel visible={true} />} */}

      <div>
        {/*Pop up to display Scheme Details*/}
        <Popup
          hideOnOutsideClick={false}
          visible={popupSchemeDetailsVisible}
          onHiding={hideSchemeDetailsPopup}
          //title={<span style={{ color: 'blue', fontWeight: 'bold' }}>SCHEME DETAILS</span>}
          title="SCHEME DETAILS"
        // title={<span style={{ color: 'blue', fontWeight: 'bold' }}>SCHEME DETAILS</span>}
        >
          <SchemeDetails
            total_debits={total_debits}
            total_credits={total_credits}
            outstanding_amount={outstanding_amount}
            lifeCoverFactor={lifeCoverFactor}
            benefitsData={benefitsSchemeData}
            IsCreditLifeCover={IsCreditLifeCover}
          />
        </Popup>
      </div>

      <section className="row">
        <h2 style={{ color: '#2E86C1', fontWeight: 'bold' }}>{GlobalParams.ClientName}</h2>
        <div style={{
          paddingTop: '0px',
          fontWeight: 'bold',
          fontFamily: 'Times New Roman, Times, serif',
          wordWrap: 'break-word'
        }} className="col-md-4">
          <div>
            <List
              dataSource={schemesData}
              searchEnabled={!GlobalParams.IsClientLoggedIn}
              noDataText="No Active Schemes Found"
              searchExpr="CompanyName"
              searchMode="contains"
              onItemClick={(e) => {
                //TODO - filter benefitsData(object Array) by scheme_id key
                //var tmp_BenefitsData = benefitsData.filter((benefit) => benefit.scheme_id === e.item.schemeID);
                //setSchemeDetails(e.item); 
                console.log(e);
                setOutstandingAmount(e.itemData.outstanding_amount);
                setTotalCredits(e.itemData.total_credits);
                setTotalDebits(e.itemData.total_debits);
                setLifeCoverFactor(e.itemData.LifeCoverFactor);
                setIsCreditLifeCover(e.itemData.IsCreditLifeCover)
                //console.log(lifeCoverFactor);
                setIsLoading(true);
                fetchSchemeBenefitsData(e.itemData.schemeID);
              }}
              itemRender={(item) => (
                <div className="card">
                  <div className="card-body">
                    <div className="card-title" style={{ color: '#2E86C1', fontWeight: 'bold', wordWrap: 'break-word' }}>
                      {item.class_name}
                    </div>
                    <p className="card-text" style={{ color: 'black', fontWeight: 'bold', fontSize: '13px' }}>
                      {JsonArrayUtility.findValueBySearchKey(
                        GlobalParams.ProductClasses,
                        'class_code',
                        item.class_code,
                        'Description'
                      )}
                    </p>
                    {GlobalParams.IsClientLoggedIn === false && (
                      <p className="card-text" style={{ color: 'black', whiteSpace: 'pre-line' }}>
                        Client: <span style={{ color: 'red', fontWeight: 'bold', fontSize: '12px' }}>{item.CompanyName}</span>
                      </p>
                    )}
                    <p className="card-text" style={{ color: 'black' }}>
                      Scheme Number: <span style={{ color: 'red', fontWeight: 'bold' }}>{item.policy_no}</span>
                    </p>
                    {GlobalParams.IsClientLoggedIn === false && (
                      <p className="card-text" style={{ color: 'black', fontSize: '13px' }}>
                        Cover Period <span> From: <span style={{ color: 'red', fontWeight: 'bold', fontSize: '12px' }}>{GlobalParams.formatDate(item.DateFrom)}</span> To: <span style={{ color: 'red', fontWeight: 'bold', fontSize: '12px' }}></span><span style={{ color: 'red', fontWeight: 'bold', fontSize: '12px' }}>{GlobalParams.formatDate(item.End_date)}</span>
                        </span>
                      </p>
                    )}
                    {/* <p className="card-text" style={{ color: 'black' }}>
                      Total Members: <span style={{ color: 'red', fontWeight: 'bold' }}>{formatIntegerWithCommas(item.total_members)}</span>
                    </p>
                    <p className="card-text" style={{ color: 'black' }}>
                      Premium Balance: <span style={{ color: 'red', fontWeight: 'bold' }}>
                        {formatNumberWithCommas(item.outstanding_amount)}
                      </span>
                    </p> */}
                    {/* <p className="card-text" style={{ color: 'black', fontSize: '13px' }}>
                      Cover Period <span> From: <span style={{ color: 'red', fontWeight: 'bold', fontSize: '12px' }}>{formatDate(item.DateFrom)}</span> To: <span style={{ color: 'red', fontWeight: 'bold', fontSize: '12px' }}></span><span style={{ color: 'red', fontWeight: 'bold', fontSize: '12px' }}>{formatDate(item.End_date)}</span>
                      </span>
                    </p> */}
                    {/* <p className="card-text" style={{ color: 'black' }}>
                      Loss Ratio <span style={{ color: 'red', fontWeight: 'bold' }}>
                        {formatNumberWithCommas(item.TotalClaimPayablePerUWYear) + ' % '}
                      </span>
                    </p> */}
                  </div>
                </div>
              )}
            />
          </div>
        </div>

        <div className="col-md-8">
          <div className="card">
            <div className="card-body">
              {/* <h5 className="card-title" style={{ color: '#2E86C1', fontWeight: 'bold' }}>Member Change Requests</h5> */}

              {/* TODO if isEndorsementLoading is true, display a loading panel */}
              {isEndorsementLoading ? (
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                  <LoadIndicator visible={true} />
                </div>
              ) : (
                <Report />

              )}
            </div>
            <div className="card-body">
              <h5 className="card-title"
                style={{ color: '#2E86C1', fontWeight: 'bold' }}>Recent Claims</h5>
              {isClaimLoading ? (
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                  <LoadIndicator visible={true} />
                </div>
              ) : (<DataGrid
                dataSource={claimsData}
                wordWrapEnabled={true}
                columns={gridColumns}
                grouping={
                  {
                    autoExpandAll: false
                  }
                }
                summary={
                  {
                    groupItems: [
                      {
                        column: 'Description',
                        summaryType: 'count',
                        showInGroupFooter: false
                      }
                    ]
                  }
                }
              />
              )}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;